import React from 'react';
import '../App.css';
import logo1 from './images/logo1.png';
import logo2 from './images/logo2.png';
import logo3 from './images/logo3.png';


export default function Sales() {
  return (
    <div className="sales-container">
      <h3 className="d-fixed">
        Companies That Increased Sales After Implementing MDQ’s PMS
      </h3>
      
      <div className="image-slider">
        <div id="carouselExampleIndicators" className="carousel slide">
          
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>

          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="carousel-content d-flex align-items-center">
                <img src={logo1} className="d-block" style={{ maxWidth: '30%' }} alt="Company 1" />
                <p>
                  Implementing the production monitoring system helped us prioritize jobs for the day and the week effectively. Earlier, lack of visibility in subcontracting processes—especially in tracking bought outs and raw material issuance—caused significant delays and material losses. With the new system in place, we’ve gained full control and clarity, drastically improving our timelines and reducing waste.
                </p>
              </div>
            </div>

            <div className="carousel-item">
              <div className="carousel-content d-flex align-items-center">
                <img src={logo2} className="d-block" style={{ maxWidth: '50%' }} alt="Company 2" />
                <p>
                  With the new system, we’re able to promptly identify issues during product manufacturing and track the entire Bill of Materials using the stock screen. From raw material issuance to final dispatch, the production flow is now fully monitored — ensuring timely releases and complete traceability across every stage.
                </p>
              </div>
            </div>

            <div className="carousel-item">
              <div className="carousel-content d-flex align-items-center">
                <img src={logo3} className="d-block" style={{ maxWidth: '40%' }} alt="Company 3" />
                <p>
                  The system has been a game-changer for iGreen product manufacturing. We can now promptly identify production issues and track the complete Bill of Materials through the stock screen. With end-to-end monitoring — from raw material issuance to final dispatch — we've achieved better control, reduced delays, and ensured timely product releases with full traceability at every step.
                </p>
              </div>
            </div>
          </div>

          {/* <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>

          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button> */}

        </div>
      </div>
    </div>
  );
}




















